import React from 'react';
import {Button, Col, Form, Input, message, Modal, Radio, Row} from "antd";
import SiderMenu from '@pages/Assembly/siderMenu';
import Breadcrumb from '@pages/Assembly/Breadcrumb';
import CommonTip from "../common";
import {Flex} from '@components';
import TitleTop from '@pages/Assembly/titleTop';
import Hint from "@pages/SelfHelp/common/hint";

import createHistory from 'history/createHashHistory';
import NHFormItem from "@components/common/NHFormItem";
import {mkbz} from "@pages/Assembly/siderMenu/menuObj";
import {getLoginUser} from "@utils/NHCore";
import NHFetch from "@utils/NHFetch";
import NHUpload from "@components/common/NHUpload";
import NextButton from "@pages/SelfHelp/common/nextIndex";

const confirm = Modal.confirm;
const basicUrl = 'api/zhxg-yxwz/jsnm/army';

createHistory();
const formItemLayout = {
    labelCol: {span: 17.5},
    wrapperCol: {span: 7.5}
};
@Form.create()
export default class FinancialPayment extends React.Component {
    constructor(props) {
        super(props);
        this.timer = React.createRef(null);
        this.state = {
            mkbz: 'GD014_2',
            hjmc: '',
            nextUrl: '',//左侧菜单加载完后传进来
            search: '',
            operable: true,//是否显示环节
            editable: false,
            saveLoading:false,
            nonOperationalData: {},//不可操作的数据
            blztFlag: "0",
            cjqkList: [{'LABEL': '是', 'VALUE': '1'}, {'LABEL': '否', 'VALUE': '0'}], // 参军情况列表
            cjqk: '', // 住宿情况, '1':住宿, '0': 走读
            sfcj: '', // 住宿情况, '1':住宿, '0': 走读

            data: '',
        };
    }

    componentDidMount() {
        this.queryQztjAndYlhj();
        // 查询业务数据
        this.getData();
    }

    getData = () => {
        let xsid = getLoginUser()?getLoginUser().userId:'';
        NHFetch(basicUrl + `/getCjDataByxsid`, 'POST',{xsid:xsid})
            .then(res => {
                if (res && res.data) {
                    this.setState({
                        editable: res.data !== null,
                        data: res.data,
                        cjqk: res.data?.CJQK,
                        sfcj: res.data?.CJQK,
                    })
                } else {
                    this.props.form.resetFields();
                }
        })
    }

    cancel = () => {
        this.setState({ editable:false })
    }

    handleOk = e => {
        e.preventDefault()
        this.props.form.validateFieldsAndScroll((err, values) => {
            if(err){
                this.setState({loading:false,saveLoading:false});
                return false;
            }
            confirm({
                title: '提示',
                content: '是否确定提交?',
                okText: '确定',
                cancelText: '取消',
                okType: 'danger',
                iconType: 'info-circle',
                onOk: () => {
                    // 处理可能为空的附件字段
                    const getValidValue = (key) =>
                        values[key] !== undefined && values[key] !== null && values[key] !== ''
                            ? values[key]
                            : null;

                    this.saveFile(
                        values['sfzgh'],
                        values['sfzrx'],
                        getValidValue('cjcl'),  // 处理 cjcl
                        getValidValue('cjcl2'),  // 处理 cjcl2
                        getValidValue('cjcl3'),  // 处理 cjcl3
                        getValidValue('cjcl4'),  // 处理 cjcl4
                        getValidValue('cjcl5'),  // 处理 cjcl5
                        () => this.handleSubmit(values)
                    );
                },
                onCancel() {
                    // 取消操作
                },
            });
        })
    }

    saveFile = (sfzgh, sfzrx, cjcl, cjcl2, cjcl3, cjcl4, cjcl5, callback) => {
        // 过滤掉空值（null/undefined/空字符串）
        const validAttachments = [cjcl, cjcl2, cjcl3, cjcl4, cjcl5]
            .filter(att => att != null && att !== '');

        // 构建请求参数（确保只传递有效值）
        const params = [sfzgh, sfzrx, ...validAttachments];

        NHFetch('api/zhxg-yxwz/dynamic/save', 'POST', params)
            .then(res => {
                if (res?.code === 200) {
                    callback();
                    this.queryQztjAndYlhj();
                    // 查询业务数据
                    this.getData();
                } else {
                    message.error('附件保存失败');
                }
            })
            .catch(error => {
                message.error('请求失败');
                console.error('Save error:', error);
            });
    }

    handleSubmit = formData => {
        const { cjqk } = this.state;
        let xsid = getLoginUser().userId?getLoginUser().userId:"";
        if(!xsid){
            message.error("登录已过期，请重新登录！");
            return;
        }
        this.setState({loading:true,saveLoading:true});
        let zzbdhjid = this.getQueryString('pkid');

        let params = {};
        params.pkid = this.state.data?.PKID,
        params.xsid = xsid || '';
        params.cjqk = cjqk || '';
        params.sfzgh = formData['sfzgh']|| '';
        params.sfzrx =  formData['sfzrx'] || '';
        params.cjcl = formData['cjcl'] || '';
        params.cjcl2 =  formData['cjcl2'] || '';
        params.cjcl3 =  formData['cjcl3'] || '';
        params.cjcl4 = formData['cjcl4'] || '';
        params.cjcl5 =  formData['cjcl5'] || '';
        params.zzbdhjid = zzbdhjid;

        NHFetch(`${basicUrl}/saveCjqk`,"POST",params)
            .then(res => {
                if (res && res.data && res.code == 200) {
                    message.success("参军情况提交成功");
                    this.setState({ loading: false,editable:false,saveLoading:false })
                    this.queryQztjAndYlhj();
                    // 查询业务数据
                    this.getData();
                    this.reloadMenu();
                } else {
                    this.setState({ loading: false,editable:true,saveLoading:false })
                    message.success("参军情况情况提交失败，请重试。");
                }

            }).catch((res) => {
            this.setState({ loading: false,saveLoading:false })
            return res;
        });
    }

    //查询前置条件和依赖环节
    queryQztjAndYlhj = () => {
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        if (!xsid) {
            this.setState({
                nonOperationalData: {nologin: true},
                operable: false,
            });
            return;
        }
        let zzbdhjid = this.getQueryString('pkid');
        NHFetch("/zzbd/queryQztjAndYlhj", 'GET', {xsid: xsid, zzbdhjid: zzbdhjid})
            .then(res => {
                if (res && res.data) {
                    let kfsj = res.data['kfsj'];
                    let ylhj = res.data['ylhj'];
                    let qzhj = res.data['qzhj'];
                    let nohj = res.data['nohj'];
                    this.setState({nonOperationalData: res.data});
                    if (kfsj && kfsj['YXSJ'] != '1') {
                        this.setState({operable: false});
                    } else if (ylhj && ylhj.length > 0) {
                        this.setState({operable: false});
                    } else if (qzhj && qzhj.length > 0) {
                        this.setState({operable: false});
                    } else if (nohj) {
                        this.setState({operable: false});
                    }
                }
            });
    }
    //重新加载菜单
    reloadMenu = () => {
        this.refs.siderMenu.reloadMenuList()
    }
    setMenuList = (menuList) => {
        let nextCount = 0;
        let bz = this.state.mkbz;
        menuList.map((elem, index) => {
            if (elem.HJDM == bz) {
                let hjmc = elem.HJMC;
                let blztFlag = elem.BLZT;
                this.setState({hjmc, blztFlag})
                nextCount = index + 1;
                return;
            }
        });
        let menu = menuList[nextCount];
        if (menu) {
            let hjdm = menu.HJDM;
            if (hjdm.indexOf('GD') == 0) {
                let gdUrl = mkbz[hjdm];
                this.setState({
                    nextUrl: gdUrl,
                    search: 'pkid=' + menu.PKID,
                })
            } else if (hjdm.indexOf('ZDY') == 0) {
                let zdyUrl = "/customLink";
                this.setState({
                    nextUrl: zdyUrl,
                    search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX,
                })
            } else if(hjdm.indexOf('DCWJ')==0){
                let wjUrl  = "/customizeExamination";
                this.setState({
                    nextUrl:wjUrl,
                    search:'pkid='+menu.PKID+'&mkbz='+hjdm,
                })
            }
        } else {
            this.setState({
                nextUrl: '',
                search: '',
            })
        }
    }
    getQueryString = (name) => {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    }

    render() {
        const {
            editable,
            cjqkList,
            data,
            cjqk,
            sfcj,
        } = this.state;
        const {form} = this.props
        return (
            <div>
                {this.state.operable ?
                    <Flex className="w1180 mt-20" align="start">
                        <SiderMenu
                            ref={"siderMenu"}
                            setMenuList={this.setMenuList}
                            title="自助报到"
                            mkbz={this.state.mkbz}
                            menuType='自助报到'
                        />
                        <Flex.Item className="page_con_r" styleName="">
                            <Breadcrumb
                                noLine
                                list={[
                                    {name: '首页', url: '/index'},
                                    {name: '自助报到', url: '/register'},
                                    {name: this.state.hjmc}
                                ]}
                            />
                            <div className="box">
                                <Hint/>
                                <TitleTop title={this.state.hjmc} extra={false}/>
                                <div style={{display: 'none'}}>
                                    <NHFormItem id={'pkid'} initialValue={data['pkid']} form={form}>
                                        <Input/>
                                    </NHFormItem>
                                </div>
                                { !editable ?
                                    <div className="form_item" style={{marginLeft: '7%'}}>
                                        <NHFormItem required={true} id={'cjqk'} initialValue={data['CJQK']} form={form}
                                                    formItemLayout={formItemLayout} label="是否参军">
                                            <Radio.Group
                                                onChange={(e) => this.setState({cjqk: e.target.value})}
                                                value={sfcj} style={{display: "flex", margin: "10px"}}>
                                                {
                                                    cjqkList && cjqkList.map((item, index) => {
                                                        return <Radio value={item.VALUE}>{item.LABEL}</Radio>
                                                    })
                                                }
                                            </Radio.Group>
                                        </NHFormItem>
                                    </div>
                                    :
                                    <>
                                        <div className="p-sw">
                                            <div className="form_item" style={{width: '100%'}}>
                                                <Row gutter={24} style={{margin: "10px 0px"}}
                                                     style={{margin: "10px 0px"}}>
                                                    <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                                        style={{color: 'rgba(0, 0, 0, 0.85)'}}>参军情况&nbsp;: </span></Col>
                                                    <Col
                                                        span={20}><span>{cjqk ? (cjqk === '1' ? '参军' : '不参军') : ''}</span></Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </>
                                }
                                {cjqk === '1' && <div className="form_item" style={{marginLeft: '7%'}}>
                                    <NHFormItem required={true} id={'sfzgh'} initialValue={data['SFZGH']} form={form}
                                                formItemLayout={formItemLayout} label="本人身份证国徽图片">

                                        <NHUpload
                                            serviceMark={'ly-sm-yxwz-svc'}
                                            moduleName={'上传本人身份证件国徽面'}
                                            multiple={false}
                                            fileCountLimit={1}
                                            isEdit={!editable}
                                            defaultEffective={true}
                                            fileTypeLimit={['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG']}
                                        />
                                    </NHFormItem>

                                    <NHFormItem required={true} id={'sfzrx'} initialValue={data['SFZRX']} form={form}
                                                formItemLayout={formItemLayout} label="本人身份证件人像面">

                                        <NHUpload
                                            serviceMark={'ly-sm-yxwz-svc'}
                                            moduleName={'上传本人身份证件人像面'}
                                            multiple={false}
                                            fileCountLimit={1}
                                            isEdit={!editable}
                                            defaultEffective={true}
                                            fileTypeLimit={['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG']}
                                        />

                                    </NHFormItem>

                                    <NHFormItem required={true} id={'cjcl'} initialValue={data['CJCL']} form={form}
                                                formItemLayout={formItemLayout} label={`应征入伍普通高等学校录取新生保留入学资格申请表`}>
                                        <NHUpload
                                            serviceMark={'ly-sm-yxwz-svc'}
                                            moduleName={'应征入伍普通高等学校录取新生保留入学资格申请表'}
                                            multiple={false}
                                            fileCountLimit={1}
                                            isEdit={!editable}
                                            defaultEffective={true}
                                            fileTypeLimit={['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG']}
                                        />

                                    </NHFormItem>
                                    <NHFormItem  id={'cjcl2'} initialValue={data['CJCL2']} form={form}
                                                formItemLayout={formItemLayout} label="参军材料1">
                                        <NHUpload
                                            serviceMark={'ly-sm-yxwz-svc'}
                                            moduleName={'参军材料1'}
                                            multiple={false}
                                            fileCountLimit={1}
                                            isEdit={!editable}
                                            defaultEffective={true}
                                            fileTypeLimit={['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG']}
                                        />

                                    </NHFormItem>
                                    <NHFormItem  id={'cjcl3'} initialValue={data['CJCL3']} form={form}
                                                formItemLayout={formItemLayout} label="参军材料2">
                                        <NHUpload
                                            serviceMark={'ly-sm-yxwz-svc'}
                                            moduleName={'参军材料2'}
                                            multiple={false}
                                            fileCountLimit={1}
                                            isEdit={!editable}
                                            defaultEffective={true}
                                            fileTypeLimit={['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG']}
                                        />

                                    </NHFormItem>
                                    <NHFormItem  id={'cjcl4'} initialValue={data['CJCL4']} form={form}
                                                formItemLayout={formItemLayout} label="参军材料3">
                                        <NHUpload
                                            serviceMark={'ly-sm-yxwz-svc'}
                                            moduleName={'参军材料3'}
                                            multiple={false}
                                            fileCountLimit={1}
                                            isEdit={!editable}
                                            defaultEffective={true}
                                            fileTypeLimit={['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG']}
                                        />

                                    </NHFormItem>
                                    <NHFormItem  id={'cjcl5'} initialValue={data['CJCL5']} form={form}
                                                formItemLayout={formItemLayout} label="参军材料4">
                                        <NHUpload
                                            serviceMark={'ly-sm-yxwz-svc'}
                                            moduleName={'参军材料4'}
                                            multiple={false}
                                            fileCountLimit={1}
                                            isEdit={!editable}
                                            defaultEffective={true}
                                            fileTypeLimit={['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG']}
                                        />

                                    </NHFormItem>

                                </div>
                                }
                                <div className="mt-50" style={{ marginLeft: '12%' }}>
                                    { (!this.state.editable  )  &&
                                        <Button type="primary" htmlType="submit" onClick={this.handleOk}
                                                loading={this.state.saveLoading}>
                                            提交
                                        </Button>
                                    }
                                    { (this.state.editable ) &&
                                        <div className=" mt-50">
                                            <Button type="primary" htmlType="submit" onClick={this.cancel}
                                                    loading={this.state.saveLoading}>
                                                修改
                                            </Button>
                                            <NextButton nextUrl={this.state.nextUrl} search={this.state.search} style={{ marginLeft: 16 }}/>
                                        </div>
                                    }

                                </div>
                            </div>
                        </Flex.Item>
                    </Flex>
                    :
                    <CommonTip hjmc={"是否参军入伍"} key={'GD014_2'} mkbz='GD014_2'
                               nonOperationalData={this.state.nonOperationalData}/>
                }
            </div>
        );
    }


}


